module.exports = __webpack_public_path__ + "static/media/welcome.7722174b.png";